module.exports = __webpack_public_path__ + "static/chhabb-2fd8dadf8005942697f6fc7c6367b400.jpg";